import React from "react";
import "./Home.css";
import { Profile } from "../Profile";

export const CameraReady = () => {
  const profilesPublications = [
    {
      title: "Dr",
      firstName: "Sunyanan",
      surname: "Choochotkaew",
      university: "IBM Research",
      bio: "https://research.ibm.com/people/sunyanan-choochotkaew",
      image: "./images/profiles/Sunyanan.webp",
      linkedin:
        "https://www.linkedin.com/in/sunyanan-choochotkaew-233a50107/?originalSubdomain=jp",
      twitter: null,
      email: "Sunyanan.Choochotkaew1@ibm.com",
    },
    {
      title: "Dr",
      firstName: "Federico",
      surname: "Montori",
      university: "University of Bologna, Italy",
      bio: "https://www.unibo.it/sitoweb/federico.montori2/en",
      image: "./images/profiles/Montori.png",
      linkedin:
        "https://www.linkedin.com/in/federico-montori/?originalSubdomain=it",
      email: "federico.montori2@unibo.it",
    },
  ];

  return (
    <div className="page-layout">
      <div className="text-layout">
        <h2>Camera-Ready Submission </h2>
        <p>
          Camera-ready versions must be uploaded to the IEEE CPS site{" "}
          <a
            href="https://ieeecps.org/cps/v2/auth/login?ak=1&pid=4iYTQ2I73IGygBY6k3vSqR"
            style={{ fontWeight: "bold", color: "red" }}
          >
            HERE
          </a>
          .
        </p>
        <p style={{ fontWeight: "bold", color: "red" }}>
          Please do not submit your final papers nor copyright forms through
          EDAS.
        </p>
        <p style={{ fontWeight: "bold", color: "red" }}>
          We do not collect them via EDAS.
        </p>
        <p>
          For the accepted papers to be included in the proceedings, the
          camera-ready version must be submitted using the recommended format
          (see below). The final PDF has to conform to the requirements for
          publishing on IEEE Xplore. The submission link will take you to the
          verification tools provided by IEEE.
        </p>
        <p>
          In addition, the IEEE copyright form has to be submitted through the
          same website. At least one author of the paper must register for the
          conference at full rate. The registration must cover any over-length
          page charge.
        </p>
        <p>
          All the steps listed above must be completed by{" "}
          <span style={{ fontWeight: "bold" }}>
            12 May 2025 (AoE timezone).
          </span>
        </p>
        <p style={{ fontStyle: "italic" }}>
          Please note that we will not be able to include your paper in the
          conference proceedings or IEEE Xplore if you do not follow the
          instructions below. The conference organizers also reserve the right
          to exclude a paper from distribution after the conference (e.g.,
          removal from IEEE Xplore) if it is not presented at the conference.
        </p>
        <br />
        <hr />
        <h2>Preparation for the Camera-Ready</h2>
        <h3>Paper Template</h3>
        <p>
          The paper should use the{" "}
          <a href="https://www.ieee.org/conferences/publishing/templates.html">
            IEEE manuscript templates for conference proceedings
          </a>
          . Make sure to use the conference mode of the template. LaTeX users
          should use the conference option of the IEEEtran document class. Refer
          to the template documentation for additional information.
        </p>
        <h3>Paper Page Limit Policy</h3>
        <p>Paper submissions must be no longer than:</p>
        <ul>
          <li>Research papers: 8 pages</li>
          <li>Industry papers: 8 pages</li>
          <li>Demo/Poster papers: 3 pages</li>
          <li>Workshop papers: 6 pages</li>
          <li>PhD Forum papers: 3 pages</li>
        </ul>
        <p>Note that the page count limit includes the references list.</p>
        <p>Extra pages are allowed as follows:</p>
        <ul>
          <li>
            For Research and industry papers: 1 extra page is allowed, with a
            100 EUR/page overlength charge.
          </li>
        </ul>
        <p>
          Please note the following restrictions:
          <ul style={{ marginTop: "10px", marginBottom: "10px" }}>
            <li>The title of Demo papers must start with "DEMO:”</li>
          </ul>
        </p>
        <h3>Copyright Form</h3>
        <p>
          Authors will be asked to fill out their copyright consent when
          uploading the camera-ready paper using the link at the top of the
          page.
        </p>
        <h3>Publication Chairs</h3>
        <div>
          {profilesPublications.map(function (data) {
            return <Profile props={data} className="profile-item" />;
          })}
        </div>
        <br />
        <hr />
        <h2>How to Submit Your Accepted Paper</h2>
        <ol>
          <li>
            Access the Author Paper Submission Site. The submission link is
            provided upon the notification.
            <img src="./images/misc/cr1.png" className="venue-img"></img>
          </li>
          <li>
            Sign in with your IEEE CPS account. Note that this is different from
            your IEEE or IEEE CS account. If you have never submitted
            camera-ready papers through this website, please sign up for a new
            account.
            {/* <img src="./images/misc/cr2.png" className="venue-img"></img>*/}
          </li>
          <li>
            Find SMARTCOMP 2024 and click on Begin Paper Submission.
            <img src="./images/misc/cr3.png" className="venue-img"></img>
          </li>
          <li>
            On the left pane, you will find information about paper
            specification (page number and extra pages charge), formatting, and
            paper validation.
            <ul>
              <li>
                Please confirm the number of pages allowed for your paper type
                and extra pages charge (if applicable).
                <img src="./images/misc/cr4.png" className="venue-img"></img>
              </li>
              <li>
                Please verify you apply the latest IEEE template. Please do not
                stamp a copyright text/bibstrip and do not add page numbers. Our
                editors will handle those tasks.
                {/* <img src="./images/misc/cr5.png" className="venue-img"></img>*/}
              </li>
              <li>
                Please check out paper validation, and select the last option,
                which is the PDF eXpress. PDF eXpress is a service provided by
                IEEE. Once you have a camera-ready candidate, please follow the
                instruction to upload the pdf to IEEE PDF eXpress website to get
                your PDF stamped for IEEE eXplore compatible. Only by then, you
                can upload the stamped PDF to the submission system.
                <img src="./images/misc/cr6.png" className="venue-img"></img>
              </li>
            </ul>
          </li>
          <li>Once you are done, click on Next at the upper right corner.</li>
          <li>
            Please put your paper details. See the below image for some hints,
            e.g., remember to capitalize your titles for consistency. Once you
            are done, please click on Next, also at the upper right corner.
            {/* <img src="./images/misc/cr7.png" className="venue-img"></img>*/}
          </li>
          <li>
            Please provide the information of all the authors. Notice that, the
            authors list MUST be consistent with that in the EDAS during
            submission. Please contact the chairs of technical tracks in advance
            if this is not the case, or your paper will not be included in the
            proceedings. We also ask you to provide ORCID IDs of all authors.
            Once you are done, please click on Next at the upper right corner.
            {/* <img src="./images/misc/cr8.png" className="venue-img"></img>*/}
          </li>
          <li>
            You can now upload your stamped (PDF eXpress validated) PDF file.
            Note that, while the webpage says “source file”, it means PDF file.
            Click on Next once you are done.
            <img src="./images/misc/cr9.png" className="venue-img"></img>
          </li>
          <li>
            Furthermore, please note the following restrictions:
            <ul style={{ marginTop: "10px", marginBottom: "10px" }}>
              <li>The title of Demo papers must start with "DEMO:”</li>
            </ul>
          </li>
          <li>
            Please complete the IEEE Copyright form and click SUBMIT IEEE
            COPYRIGHT.
            <img src="./images/misc/cr11.png" className="venue-img"></img>
          </li>
          <li>
            Once you complete the copyright form, you are done. The publication
            chairs will validate the production materials and contact you if
            needed. Most common issues in the past years include:
            <ul>
              <li>Titles that are not properly capitalized</li>
              <li>Different author list</li>
              <li>Author lists not following IEEE format</li>
              <li>Incorrect paper size or margin</li>
              <li>Overlength submission</li>
              <li>Fonts not embedded</li>
              <li>Type-3 fonts</li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  );
};
